import { Divider, Skeleton, Table } from "antd";
import { useIntl } from "react-intl";
import "./PromotionRelegationRules.scss";
import { AddPromotionRelegationRulesButton } from "~Features/EditSeason/components/PromotionRelegationRules/components/AddPromotionRelegationRulesButton.tsx";
import { useGetPromotionRelegationRuleColumns } from "~Features/EditSeason/components/PromotionRelegationRules/hooks/useGetPromotionRelegationRuleColumns.tsx";
import type { PromotionRelegationRuleTableRow } from "~Features/EditSeason/components/PromotionRelegationRules/types/promotionRelegationRuleTableRow.ts";
import { useUpdateSeason } from "~Features/EditSeason/hooks/useUpdateSeason.ts";
import type { Season } from "~types/season.ts";

type Props = {
  season: Season | null;
};

export const PromotionRelegationRules = ({ season }: Props) => {
  const { formatMessage } = useIntl();

  const rules: PromotionRelegationRuleTableRow[] = (season?.promotionRelegationRules || []).map((item, index) => ({
    ...item,
    id: index,
  }));

  const { mutateAsync: upsertRules, isPending: isUpserting } = useUpdateSeason();

  const handleAdd = async () => {
    await upsertRules({ promotionRelegationRules: rules.map((item) => ({ ...item, id: undefined })) });
  };

  const handleDelete = async (row: PromotionRelegationRuleTableRow) => {
    await upsertRules({
      promotionRelegationRules: rules.filter((item) => item.id !== row.id).map((item) => ({ ...item, id: undefined })),
    });
  };

  const columns = useGetPromotionRelegationRuleColumns(handleDelete, handleAdd, isUpserting);

  if (!season) return <Skeleton />;

  return (
    <div className="promotion-relegation-rules">
      <Divider plain>{formatMessage({ id: "promotion.relegation.rules" })}</Divider>
      <div className="add-button-container">
        <AddPromotionRelegationRulesButton rules={rules} onAdd={handleAdd} loading={isUpserting} />
      </div>
      <Table
        loading={isUpserting}
        className="relegation-block"
        columns={columns}
        dataSource={rules}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
};
